import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';
//import contact from "../pages/Contact";

function Footer() {
  return (
    <footer className="footer mt-auto py-4 bg-dark text-white dark-footer">
      <div className="container-fluid">
        <div className="row">

          {/* Quick Links 
          <div className="col-md-4 mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              
            </ul>
          </div>*/}

          {/* Contact Us */}
          <div className="col-md-6 mb-3">
            <h5>Contact Us</h5>
            <address className="mb-0">
              Grey Imports Australia Pty Ltd<br/>26 Havelock Road <br/>Bayswater, VIC 3153 <br/>k69Eha<br/>
            </address>
          </div>

          {/* Social Media */}
          <div className="col-md-6 mb-3 text-md-end">
            <h5>Follow Us</h5>
            <a href="https://www.facebook.com/people/Grey-Imports/61550986204761/" className="me-3 text-reset"><i className="bi bi-facebook fs-5"></i></a>
            <a href="https://www.youtube.com/@GreyImports" className="me-3 text-reset"><i className="bi bi-youtube fs-5"></i></a>
            <a href="https://www.instagram.com/greyimportsau/" className="me-3 text-reset"><i className="bi bi-instagram fs-5"></i></a>
           
          </div>
        </div>

         <div className="row mt-3">
          <div className="col-12 text-center small">
            &copy; {new Date().getFullYear()} Grey Imports. All rights reserved.
            <span className="mx-2">|</span> {/* ✅ ADDED: separator */}
            <a
              className="text-reset text-decoration-none"
              href="https://www.mdlreports.com.au/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;